import React, { Fragment, useEffect, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import NumberFormat from "react-number-format";

import { validateAdress, validateNumberYear2, validateOnlyNumbers, validateTextOnlyAlphanumeric, validatorField, validateNumberYear3 } from "../../../Utils/validators";

import ErrorCustom from "../../../Components/errorCustom";
import IconPlus from "../../../Resources/svg/Icons/IconPlus";
import { FamilyContributionForm } from "../familyContributionForm";
import { BusinessActivityForm } from "../businessActivityForm";
import { ParentForm } from "../parentForm";
import { LegalEntityForm } from "../legalEntityForm";
import { ParentPepForm } from "../parentPep";
import { API } from 'aws-amplify';
import { accountPrefix, accountTypeList, bankList, indicatorTypeAccount, indicatorTypeCurrency, inputKey, typeValueCurrency } from "../../../Utils/constants";
interface Props {
  data: any;
  orders: any;
  setOrders: any;
  variant: any;
  setData?: any;
  setShowSupport?: any;
  codProduct?: any;
  acumuladoOrigenesFondo?: any;
  resultedAmount?: any;
  setValidOptionalValues?: any;
};


const Quiz = ({
  /*title, register, */ data,
  /*errors, */ orders,
  setOrders,
  variant,
  setData,
  setShowSupport,
  codProduct,
  acumuladoOrigenesFondo,
  resultedAmount,
  setValidOptionalValues
}: Props) => {
  const methods = useFormContext();
  const { register, errors, control, watch, setValue, getValues, setError, clearError, triggerValidation } = methods;
  const [showQuizOne, setShowQuizOne] = useState<boolean>(false);
  const [showQuizTwo, setShowQuizTwo] = useState<boolean>(false);
  const [showQuizThree, setShowQuizThree] = useState<boolean>(false);
  const objeTageo: any = useRef({});

  const [contributions, setContributions] = useState<any>([]);
  const [contributionsData, setContributionsData] = useState<any>([]);

  const [activities, setActivities] = useState<any>([]);
  const [activitiesData, setActivitiesData] = useState<any>([]);

  const [parents, setParents] = useState<any>([]);
  const [parentsData, setParentsData] = useState<any>([]);

  const [legalEntities, setLegalEntities] = useState<any>([]);
  const [legalEntitiesData, setLegalEntitiesData] = useState<any>([]);

  const [parentsPep, setParentsPep] = useState<any>([]);
  const [parentsPepData, setParentsPepData] = useState<any>([]);
  const [ bankAccount, setBankAccount ] = useState<any>()

  const selectedBank = watch(inputKey.SELECTED_BANK);
    const accountType = watch(inputKey.ACCOUNT_TYPE);

  const handleChange = (e: any, pos: any, value: any) => {
    if (e.target.value != value) {
      setOrders([...orders, `${pos}.`]);
    } else {
      setOrders(orders.filter((elem: any) => elem !== `${pos}.`));
    }

    if (e.target.value === "1" && pos === "a") {
      setShowQuizOne(true);
    } else {
      setShowQuizOne(false);
    }
  };


   const getQuestionsList = async () => {
  
      const response = await API.post('api-rentas', '/quiz', {
        body: { section: 'LISTBANCOS' }
      });
      
      if(response.status){
        let clone = JSON.parse(JSON.stringify(response.data))
       const cuentas = {
        'Ahorros': clone[0].data['Ahorros'],
        'Cuenta corriente': clone[0].data['Cuenta corriente'],
        'Cuenta maestra': clone[0].data['Cuenta maestra']
      };
        setBankAccount(cuentas);

      }
    }

  const handleChange2 = (e: any, pos:any, value: any) => {
    if (e.target.value != value) {
      setOrders([...orders, `${pos}.`]);
    } else {
      setOrders(orders.filter((elem: any) => elem !== `${pos}.`));
    }

    if (e.target.value === "1" && pos === "b") {
      setShowQuizTwo(true);
    } else {
      setShowQuizTwo(false);
    }
  };

  const handleChange3 = (e: any, pos: any, value: any) => {
    if (e.target.value != value) {
      setOrders([...orders, `${pos}.`]);
    } else {
      setOrders(orders.filter((elem: any) => elem !== `${pos}.`));
    }

    if(e.target.value === "1" && pos === "c"){
      setShowQuizThree(true);
    } else {
      setShowQuizThree(false);
    }
  }

  const handleSelection = ({ target }: any, idx: number) => {
    data.forEach((el: any) => {
      if(el.metadata.key == idx + 1){
        el.active = !el.active;
      }
    })
    const hasActive = data
    .filter((el: any) => el.questionType === "formGroup")
    .some((el: any) => el.active === true);
    setShowSupport(hasActive);
    setData([...data])
    //checked,id,value
    objeTageo.current[idx] = target.checked;
    if (objeTageo.current[idx]) {
      window.digitalData.push({
        metadata: {
          key: "Origen de Fondos – Inversión Global",
          value: target.id,
        },
        event: "trackMetadata",
      });
    }
  };

  const addCommas = (num: any) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = (num: any) => num.toString().replace(/[^0-9]/g, "");
    
    const quizAccount = data.filter((item: any) => item.metadata.accountCredit);

    const quizOne = data.slice(0, 5);
    const quizTwo = data.slice(5, 9);
    const quizThree = data.slice(9, 11);

    const [filteredQuizTwo, setFilteredQuizTwo] = useState(() =>
      quizTwo.filter(
        (items: any) =>
          items.questionType === "formGroup" &&
          items.metadata.classContainer === "subQuestion"
      )
    );

  const [optionalValue, setOptionalValue] = useState<any>({
    companyNameSk: "",
    rucSk: "",
    percentParticipationSk: "",
  });

  useEffect(() => {
    if (!filteredQuizTwo || filteredQuizTwo.length < 2) return;
  
    const secondObject = filteredQuizTwo[1];
  
    if (!secondObject.childControls) return;
  
    const childControls = secondObject.childControls;
  
    setOptionalValue({
      companyNameSk: childControls.length > 0 ? childControls[0].sk : "",
      rucSk: childControls.length > 1 ? childControls[1].sk : "",
      percentParticipationSk: childControls.length > 2 ? childControls[2].sk : "",
    });
  }, [filteredQuizTwo]);

  const updateContribution = () => {
    let newContributions = contributions.map((id: any) => {
      return {...id };
    });

    setContributions(newContributions);
  }

  const updateActivity = () => {
    let newActivities = activities.map((id: any) => {
      return {...id }
    });

    setActivities(newActivities);
  }

  const updateParent = () => {
    let newParents = parents.map((id: any) => {
      return {...id }
    });

    setParents(newParents);
  }

  const updateLegalEntity = () => {
    let newLegalEntities = legalEntities.map((id: any) => {
      return {...id }
    });

    setLegalEntities(newLegalEntities);
  }

  const updateParentPep = () => {
    let newParentsPep = parentsPep.map((id: any) => {
      return {...id }
    });

    setParentsPep(newParentsPep);
  }

  const removeContribution = (index: any) => {
    contributions.splice(index, 1);
    setContributions(contributions);
    updateContribution();
  }

  const removeActivity = (index: any) => {
    activities.splice(index, 1);
    setActivities(activities);
    updateActivity();
  }

  const removeParent = (index: any) => {
    parents.splice(index, 1);
    setParents(parents);
    updateParent();
  }

  const removeLegalEntity = (index: any) => {
    legalEntities.splice(index, 1);
    setLegalEntities(legalEntities);
    updateLegalEntity();
  }

  const removeParentPep = (index: any) => {
    parentsPep.splice(index, 1);
    setParentsPep(parentsPep);
    updateParentPep();
  }

  useEffect(() => {
    if(selectedBank){setValue(inputKey.ACCOUNT_NUMBER, '')
    triggerValidation(inputKey.ACCOUNT_NUMBER)}
  }, [selectedBank])

  const validateLengthBank = (value: string) => {
    const allValues: Record<string, string> = getValues();
    const currentBank = allValues[inputKey.SELECTED_BANK] || '';
    const currentAccountType = allValues[inputKey.ACCOUNT_TYPE] || '';
    const requiredLength = bankAccount[currentAccountType][currentBank] || 6;
    const bcpNames = [bankList.BCP, bankList.BCP_DOLARES, bankList.BCP_SOLES];
    if (value.length !== requiredLength) {
      return `Debe tener ${requiredLength} caracteres`;
    } 
    if(bcpNames.includes(currentBank) && currentAccountType !== accountTypeList.MASTER){
      const thirdToLastDigit = value.trim().slice(-3, -2);
      const selectedCurrency = allValues[inputKey.SELECTED_CURRENCY] || '';

      const isSoles = selectedCurrency === indicatorTypeCurrency.PEN;
      const isDolares = selectedCurrency === indicatorTypeCurrency.USD;

      if ((isSoles && thirdToLastDigit !== typeValueCurrency.PEN) || (isDolares && thirdToLastDigit !== typeValueCurrency.USD)) {
        return "El número de cuenta ingresado no corresponde al tipo de moneda seleccionado.";
      }
    }

    if (currentBank === bankList.BBVA) {
      const prefix = value.trim().slice(0, 4);
      const indicator = value.trim().slice(10, 12);
      if (prefix !== accountPrefix.BBVA) {
        return "El número de cuenta BBVA debe iniciar con 0011";
      }
      
      const indicatorMap: Record<string, string> = {
        [accountTypeList.SAVING]: indicatorTypeAccount.SAVING,
        [accountTypeList.CURRENT]: indicatorTypeAccount.CURRENT,
      };

      const expectedIndicator = indicatorMap[currentAccountType];
      if (expectedIndicator && indicator !== expectedIndicator) {
        return "El número de cuenta no coincide con el tipo de cuenta seleccionado";
      }
    }
  };

  const addItemControl = (e: any, type: string) => {
    e.preventDefault();

    if(type === "contribution") availableContributions() ? setContributions(contributions.concat(generateControlObject(contributionsData, type))) : false;
    else if(type === "activity") availableActivities() ? setActivities(activities.concat(generateControlObject(activitiesData, type))) : false;
    else if(type === "parent") availableParents() ? setParents(parents.concat(generateControlObject(parentsData, type))) : false;
    else if(type === "legalEntity") availableLegalEntities() ? setLegalEntities(legalEntities.concat(generateControlObject(legalEntitiesData, type))) : false;
    else if(type === "parentPep") availableParentsPep() ? setParentsPep(parentsPep.concat(generateControlObject(parentsPepData, type))) : false;
  }

  const currencySymbol = (currency: string) => {
    if(currency === "USD" || currency === "Dólares") return "$."
    if(currency === "PEN" || currency === "Soles") return "S/."
  }

  const getContributionsData = () => {
    const filterContributions = data.find((item: any) => item.title === "Aporte Familiar");
    if (filterContributions) {
      setContributionsData(filterContributions.childControls);
    } else {
      setContributionsData([]);
    }
  };

  const getActivitiesData = () => {
    const filterActivities = data.find((item: any) => item.title === "Actividad Empresarial");
    if (filterActivities) {
      setActivitiesData(filterActivities.childControls);
    } else {
      setActivitiesData([]);
    }
  };

  const getParentsData = () => {
    const filterParents = filteredQuizTwo[0];
    if (filterParents) {
      setParentsData(filterParents.childControls);
    } else {
      setParentsData([]);
    }
  }

  const getLegalEntitiesData = () => {
    const filterLegalEntities = filteredQuizTwo[1];
    if (filterLegalEntities) {
      setLegalEntitiesData(filterLegalEntities.childControls);
    } else {
      setLegalEntitiesData([]);
    }
  }

  const getParentPepData = () => {
    const filterParents = quizThree[1];
    if (filterParents) {
      setParentsPepData(filterParents.childControls);
    } else {
      setParentsPepData([]);
    }
  }
  
  const availableContributions = (): boolean => {
    return contributions.length < 3;
  }

  const availableActivities = (): boolean => {
    return activities.length < 3;
  }

  const availableParents = (): boolean => {
    return parents.length < 3;
  }

  const availableLegalEntities = (): boolean => {
    return legalEntities.length < 3;
  }

  const availableParentsPep = (): boolean => {
    return parentsPep.length < 3;
  }

  const generateControlObject = (
    controlArr: Array<any>,
    type: "contribution" | "activity" | "parent" | "legalEntity" | "parentPep",
  ) => {
    const suffix = `/${type === "contribution" ? contributions.length + 1 : type === "activity" ? activities.length + 1 : type === "parent" ? parents.length + 1 : type === "legalEntity" ? legalEntities.length + 1 : type === "parentPep" ? parentsPep.length + 1 : ""}`;
  
    return controlArr.reduce((acc, item) => {
      if (item.childControls) {
        item.childControls.forEach((control: any) => {
          acc[`${control.sk}${suffix}`] = "";
        });
      } else {
        acc[`${item.sk}${suffix}`] = "";
      }
      return acc;
    }, {} as Record<string, string>);
  };

  const validateOptionalFields = (value: any, type: any) => {
    if (!value) return true;
    switch (type) {
      case "RUC":
        if (value.length !== 11) {
          return "*Revisa los datos ingresados.";
        }
        if (!validateOnlyNumbers(value)) return "El campo debe contener solo números";
        break;
      case "% de Participación":
        if (parseFloat(value) < 25 || parseFloat(value) > 100) return "Ingrese un porcentaje válido";
        if (!validateOnlyNumbers(value)) return "El campo debe contener solo números";
        break;
      case "Razón social":
        if (value === "") return "*Revisa los datos ingresados.";
        break;
      default:
        return true;
    }
  
    return true;
  };

  useEffect(() => { 
    if(variant !== 2) return;
    if (watch(optionalValue["companyNameSk"]) || watch(optionalValue["rucSk"]) || watch(optionalValue["percentParticipationSk"])) {
      setFilteredQuizTwo((prev: any) => {
        if (prev.length > 1) {
          const updatedChildControls = prev[1].childControls.map((control: any) => ({
            ...control,
            required: true
          }));
  
          return [
            ...prev.slice(0, 1),
            { ...prev[1], childControls: updatedChildControls },
            ...prev.slice(2)
          ];
        }
        return prev;
      });
      if (watch(optionalValue["companyNameSk"]) && watch(optionalValue["rucSk"]) && watch(optionalValue["percentParticipationSk"])) {
        if(errors && Object.keys(errors).length > 0) return;
        setValidOptionalValues(true);
      } else {
        setValidOptionalValues(false);
      }
    } else {
      setFilteredQuizTwo(
        quizTwo.filter(
          (items: any) =>
            items.questionType === "formGroup" &&
            items.metadata.classContainer === "subQuestion"
        ).map((item: any) => ({
          ...item,
          childControls: item.childControls.map((control: any) => ({
            ...control,
            required: false
          }))
        }))
      );
      setValidOptionalValues(true);
    }
  }, [watch(optionalValue["companyNameSk"]), watch(optionalValue["rucSk"]), watch(optionalValue["percentParticipationSk"])]);

  useEffect(() => {
    getContributionsData();
    getActivitiesData();
    getParentsData();
    getLegalEntitiesData();
    getParentPepData();
    getQuestionsList()
  }, [data]);

  return (
    <>
      {variant === 1 ? (
        <>
          {resultedAmount && <p style={{marginTop: "20px"}}>Ingresa los datos de orígenes de fondo para el importe de {currencySymbol(resultedAmount.currency)} {resultedAmount.amount.toFixed(2)}</p>}
          {
            data.map((items: any, index: number) => (
              <Fragment key={index}>
                {items.questionType === "checkbox" && !items.metadata.accountCredit && (
                  <>
                    <div className="form-register__optional-title">
                      a) {items.title}
                    </div>
                    {items.metadata.options.map((option: any, idx: number) => (
                      <div className="question__control__checkbox" key={idx}>
                        <div
                          className="question__control__checkbox__item"
                        >
                          <label>
                            <input
                              type="checkbox"
                              id={option.value}
                              name={items.sk}
                              className="filled-in"
                              value={option.id}
                              ref={register({ validate: validatorField })}
                              onChange={(e) => handleSelection(e, idx)}
                            />
                            <span>{option.value}</span>
                          </label>
                        </div>
                      </div>
                    ))}
                    <ErrorCustom errors={errors} name={items.sk} />
                  </>
                )}
    
                {items.questionType === "title" && !items.metadata.accountCredit && (
                  <div className="clientForm__question">
                    <div className="clientForm__title">{items.title}</div>
                  </div>
                )}
    
                {items.questionType === "formGroup" && !items.metadata.accountCredit  && items.active && (
                  <div className="healthCard">
                    <div className="clientForm__exchange-rate">
                      <div className="clientForm__title">
                        {items.title}
                      </div>
                      {acumuladoOrigenesFondo && <div><span>Tipo de cambio: </span>{acumuladoOrigenesFondo.usdToPenRate}</div>}
                    </div>
    
                    {items.childControls &&
                      items.childControls.map((child: any, index: number) => {
                        const amountChildValue = watch(child.sk, "");
                        
                        return (
                          <Fragment key={index}>
                            {child.questionType == "inputGroup" && (
                              <div className="question__control input-field">
                                <div className="group-form">
                                  {child.childControls &&
                                    child.childControls.map((childControl: any, idx: number) => {
                                      return (
                                        <Fragment key={idx}>
                                          {childControl.questionType ===
                                            "select" && (
                                            <div className="question__control input-field">
                                              <select
                                                id={childControl.sk}
                                                name={childControl.sk}
                                                ref={register({
                                                  validate: validatorField,
                                                })}
                                              >
                                                <option
                                                  value={""}
                                                  disabled
                                                  selected
                                                >
                                                  {
                                                    childControl.metadata
                                                      .placeholder
                                                  }
                                                </option>
                                                {childControl.metadata.options.map(
                                                  (option: any, idx: number) => (
                                                    <option
                                                      value={option}
                                                      key={idx}
                                                    >
                                                      {option}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                              <ErrorCustom
                                                errors={errors}
                                                name={childControl.sk}
                                              />
                                            </div>
                                          )}
                                          {childControl.questionType === "input" && (
                                            <>
                                              <div className="question__control input-field">
                                                {childControl.metadata && (
                                                  <>
                                                    {childControl.metadata
                                                      .displayNumber && (
                                                      <>
                                                        {childControl.metadata
                                                          .amountFormat ? (
                                                          <>
                                                            <Controller
                                                              as={NumberFormat}
                                                              id={childControl.sk}
                                                              name={childControl.sk}
                                                              control={control}
                                                              maxLength={
                                                                childControl
                                                                  .metadata
                                                                  .maxLength
                                                              }
                                                              rules={{
                                                                required: true,
                                                              }}
                                                            />
                                                            <label
                                                              htmlFor={
                                                                childControl.sk
                                                              }
                                                            >
                                                              {
                                                                childControl
                                                                  .metadata
                                                                  .placeholder
                                                              }
                                                            </label>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <Controller
                                                              as={NumberFormat}
                                                              id={childControl.sk}
                                                              name={childControl.sk}
                                                              control={control}
                                                              maxLength={
                                                                childControl
                                                                  .metadata
                                                                  .maxLength
                                                              }
                                                              rules={{
                                                                required: true,
                                                              }}
                                                            />
                                                            <label
                                                              htmlFor={
                                                                childControl.sk
                                                              }
                                                            >
                                                              {
                                                                childControl
                                                                  .metadata
                                                                  .placeholder
                                                              }
                                                            </label>
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                    {!childControl.metadata
                                                      .displayNumber && (
                                                      <>
                                                        <input
                                                          id={childControl.sk}
                                                          name={childControl.sk}
                                                          type="text"
                                                          autoComplete="off"
                                                          maxLength={
                                                            childControl.metadata
                                                              .maxLength
                                                          }
                                                          ref={register({
                                                            validate:
                                                              validatorField,
                                                          })}
                                                        />
                                                        <label
                                                          htmlFor={childControl.sk}
                                                        >
                                                          {
                                                            childControl.metadata
                                                              .placeholder
                                                          }
                                                        </label>
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                                <ErrorCustom
                                                  errors={errors}
                                                  name={childControl.sk}
                                                />
                                              </div>
                                            </>
                                          )}
                                        </Fragment>
                                      );
                                    })}
                                </div>
                              </div>
                            )}
    
                            {child.questionType === "select" && (
                              <div className="question__control input-field">
                                <select
                                  id={child.sk}
                                  name={child.sk}
                                  ref={register({ validate: validatorField })}
                                >
                                  <option value={""} disabled selected>
                                    {child.metadata.placeholder}
                                  </option>
                                  {child.metadata.options &&
                                    child.metadata.options.map(
                                      (option: any, idx: number) => (
                                        <option value={option} key={idx}>
                                          {option}
                                        </option>
                                      )
                                    )}
                                </select>
                                <ErrorCustom errors={errors} name={child.sk} />
                              </div>
                            )}
    
                            {child.questionType === "input" && (
                              <div className="question__control input-field">
                                {child.metadata && (
                                  <>
                                    {child.metadata.displayNumber && (
                                      <>
                                        {child.metadata.amountFormat ? (
                                          <>
                                            <input
                                              id={child.sk}
                                              name={child.sk}
                                              type="text"
                                              autoComplete="off"
                                              maxLength={child.metadata.maxLength}
                                              ref={register({
                                                validate: {
                                                  validateTextOnlyAlphanumeric,
                                                  validatorField,
                                                },
                                              })}
                                              onChange={(event: any) => {
                                                setValue(
                                                  child.sk,
                                                  addCommas(
                                                    removeNonNumeric(
                                                      event.target.value
                                                    )
                                                  )
                                                );
                                              }}
                                            />
                                            <label
                                              htmlFor={child.sk}
                                              className={
                                                amountChildValue
                                                  ? "active"
                                                  : "false"
                                              }
                                            >
                                              {child.metadata.placeholder}
                                            </label>
                                          </>
                                        ) : child.metadata.alphanumeric ? (
                                          <>
                                            <input
                                              id={child.sk}
                                              name={child.sk}
                                              type="text"
                                              autoComplete="off"
                                              maxLength={child.metadata.maxLength}
                                              ref={register({
                                                validate: {
                                                  validateAdress,
                                                  validatorField,
                                                },
                                              })}
                                            />
                                            <label htmlFor={child.sk}>
                                              {child.metadata.placeholder}
                                            </label>
                                          </>
                                        ) : (
                                          <>
                                            <Controller
                                              as={NumberFormat}
                                              id={child.sk}
                                              name={child.sk}
                                              control={control}
                                              maxLength={child.metadata.maxLength}
                                              rules={{ required: true }}
                                            />
                                            <label htmlFor={child.sk}>
                                              {child.metadata.placeholder}
                                            </label>
                                          </>
                                        )}
                                      </>
                                    )}
                                    {!child.metadata.displayNumber && (
                                      <>
                                        <input
                                          id={child.sk}
                                          name={child.sk}
                                          type="text"
                                          autoComplete="off"
                                          maxLength={child.metadata.maxLength}
                                          ref={register({
                                            validate: validatorField,
                                          })}
                                        />
                                        <label htmlFor={child.sk}>
                                          {child.metadata.placeholder}
                                        </label>
                                      </>
                                    )}
                                  </>
                                )}
                                <ErrorCustom errors={errors} name={child.sk} />
                              </div>
                            )}
                            
                          </Fragment>
                        );
                      })}
    
                      {items.title === "Aporte Familiar" && (
                        <div className="clientForm__container">
                          {contributions.map((contribution: any, index: number) => (
                              <FamilyContributionForm 
                                key={index} 
                                disableRemove={contributions.length !== index + 1}
                                contributionsData={contributionsData}
                                contribution={contribution}
                                index={index}
                                removeContribution={removeContribution}
                                count={contributions.length}
                              />
                            ))}
                            <div className={`clientForm__add ${!availableContributions() ? "disabled-action" : ""}`} onClick={(e) => addItemControl(e, "contribution")}>
                              <IconPlus />
                              <p className="clientForm__add-text">
                                Agregar Aporte Familiar
                              </p>
                            </div>
                        </div>
                      )}
    
                      {items.title === "Actividad Empresarial" && (
                        <div className="clientForm__container">
                          {activities.map((activity: any, index: number) => (
                            <BusinessActivityForm 
                              key={index}
                              disableRemove={activities.length !== index + 1} 
                              activitiesData={activitiesData}
                              activity={activity}
                              index={index}
                              removeActivity={removeActivity}
                              count={activities.length}
                            />
                          ))}
                          <div className={`clientForm__add ${!availableActivities() ? "disabled-action" : ""}`} onClick={(e) => addItemControl(e, "activity")}>
                            <IconPlus />
                            <p className="clientForm__add-text">
                              Agregar Actividad Empresarial
                            </p>
                          </div>
                        </div>
                      )}
                  </div>
                )}

                {items.questionType === "textarea" && (
                  <>
                    {!items.metadata.hiddenTitle && (
                      <div className="form-register__optional-title--b">
                        {items.metadata.numeration
                          ? `${items.metadata.numeration}) `
                          : ``}
                        {items.title}
                      </div>
                    )}
                    <div className="question__control__textarea input-field">
                      <textarea
                        id={items.sk}
                        name={items.sk}
                        ref={register({ validate: validatorField })}
                        className="materialize-textarea"
                        maxLength={
                          items.metadata && items.metadata.maxLength
                            ? items.metadata.maxLength
                            : 100
                        }
                      ></textarea>
                      <label htmlFor={items.sk}>
                        {items.metadata && items.metadata.placeholder}
                      </label>
                      <ErrorCustom errors={errors} name={items.sk} />
                    </div>
                  </>
                )}
              </Fragment>
            ))
          }

          {codProduct == "RG" && 
            <>
              {quizAccount.map((items: any, index: number) => (
                <Fragment key={index}>
                  {items.questionType === "title" && items.metadata.accountCredit && (
                    <div className="clientForm__question">
                      <div className="clientForm__title">{items.title}</div>
                    </div>
                  )}
      
                  {items.questionType === "select" && items.metadata.accountCredit && (
                    <div className="question__control input-field">
                      <select
                        id={items.sk}
                        name={items.sk}
                        ref={register({ validate: validatorField })}
                      >
                        <option value={""} disabled selected>
                          {items.metadata.placeholder}
                        </option>
                        {items.metadata.options &&
                          items.metadata.options.map(
                            (option: any, idx: number) => (
                              <option value={option} key={idx}>
                                {option}
                              </option>
                            )
                          )}
                      </select>
                      <ErrorCustom errors={errors} name={items.sk} />
                    </div>
                  )}
      
                  {items.questionType === "input" && items.metadata.accountCredit && bankAccount && (
                    <div className="question__control input-field">
                      {items.metadata && (
                        <>
                          {items.metadata.displayNumber && (
                            <>
                              {items.metadata.alphanumeric ? (
                                <>
                                <Controller
                              autoComplete="off"
                              as={ <NumberFormat
                              allowLeadingZeros
                              isNumericString={false}
                              autoComplete="off"
                              disabled={selectedBank === '' || accountType === ''}
                              maxLength={items.metadata.maxLength}
                            />}
                              id={items.sk}
                              name={items.sk}
                              disabled={ selectedBank == '' || accountType == '' ? true : false}
                              control={control}
                              maxLength={items.metadata.maxLength}
                              rules={{
                                required: "*Revisa los datos ingresados.",
                                validate: validateLengthBank,
                              }}
                            />
                                  <label htmlFor={items.sk}>
                                    {items.metadata.placeholder}
                                  </label>
                                </>
                              ) : (
                                <>
                                  <Controller
                                    as={NumberFormat}
                                    id={items.sk}
                                    name={items.sk}
                                    control={control}
                                    maxLength={items.metadata.maxLength}
                                    rules={{ required: true }}
                                  />
                                  <label htmlFor={items.sk}>
                                    {items.metadata.placeholder}
                                  </label>
                                </>
                              )}
                            </>
                          )}
                          {!items.metadata.displayNumber && (
                            <>
                              <input
                                id={items.sk}
                                name={items.sk}
                                type="text"
                                autoComplete="off"
                                maxLength={items.metadata.maxLength}
                                ref={register({
                                  validate: validatorField,
                                })}
                              />
                              <label htmlFor={items.sk}>
                                {items.metadata.placeholder}
                              </label>
                            </>
                          )}
                        </>
                      )}
                      <ErrorCustom errors={errors} name={items.sk} />
                    </div>
                  )}
                </Fragment>
            ))}
            </>
          }
        </>
      ) : (
        <>
          <div className="healthCard">
            {quizOne.map((items: any, index: any) => (
              <div key={index}>
                {items.questionType === "boolean" && (
                  <>
                    {!items.metadata.hiddenTitle && (
                      <p>
                        a){" "}
                        {items.metadata.numeration
                          ? `${items.metadata.numeration}) `
                          : ``}
                        {items.title !== "Otros datos" && items.title}
                      </p>
                    )}
                    <div className="clientForm__form__item">
                      <label>
                        <input
                          className="with-gap"
                          name={items.sk}
                          type="radio"
                          ref={register({ validate: validatorField })}
                          value="1"
                          onChange={(e) => handleChange(e, "a", 1)}
                        />
                        <span>Sí</span>
                      </label>
                      <label>
                        <input
                          className="with-gap"
                          name={items.sk}
                          type="radio"
                          ref={register({ validate: validatorField })}
                          value="0"
                          onChange={(e) => handleChange(e, "a", 0)}
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </>
                )}
              </div>
            ))}
            {showQuizOne && (
              <div className="clientForm__question">
                <div className="clientForm__title">
                  Detalla esta información
                </div>
                {quizOne.map((items: any, index: number) => (
                  <Fragment key={index}>
                    {items.questionType === "select" && (
                      <div className="question__control">
                        <select
                          id={items.sk}
                          name={items.sk}
                          ref={register({ validate: validatorField })}
                        >
                          <option value={""} disabled selected>
                            {items.metadata.placeholder}
                          </option>
                          {items.metadata.options.map(
                            (option: any, idx: number) => (
                              <option value={option} key={idx}>
                                {option}
                              </option>
                            )
                          )}
                        </select>
                        <ErrorCustom errors={errors} name={items.sk} />
                      </div>
                    )}
                    {items.questionType === "input" && (
                      <>
                        {items.metadata.placeholder === "Año" && (
                          <div className="question__control input-field percent">
                            <Controller
                              autoComplete="off"
                              as={NumberFormat}
                              id={items.sk}
                              name={items.sk}
                              control={control}
                              maxLength={items.metadata.maxLength}
                              rules={{
                                required: "*Revisa los datos ingresados.",
                                validate: validateNumberYear2,
                              }}
                            />
                            <div className="tooltip">
                              El valor ingresado no puede ser mayor al año actual.
                            </div>
                            <label htmlFor={items.sk}>
                              {items.metadata && items.metadata.placeholder}
                            </label>
                            <ErrorCustom errors={errors} name={items.sk} />
                          </div>
                        )}
                      </>
                    )}
                    {items.questionType === "textarea" && (
                      <>
                        <div className="question__control__textarea input-field">
                          <textarea
                            id={items.sk}
                            name={items.sk}
                            ref={register({
                              validate: validatorField,
                            })}
                            className="materialize-textarea"
                            maxLength={
                              items.metadata && items.metadata.maxLength
                                ? items.metadata.maxLength
                                : 500
                            }
                          ></textarea>
                          <label htmlFor={items.sk}>
                            {items.metadata && items.metadata.placeholder}
                          </label>
                          <ErrorCustom errors={errors} name={items.sk} />
                        </div>
                      </>
                    )}
                  </Fragment>
                ))}
              </div>
            )}
          </div>

          <div className="healthCard">
            {quizTwo.map((items: any, index: number) => (
              <div key={index}>
                {items.questionType === "boolean" && (
                  <>
                    {!items.metadata.hiddenTitle && (
                      <p>
                        b){" "}
                        {items.metadata.numeration
                          ? `${items.metadata.numeration}) `
                          : ``}
                        {items.title !== "Otros datos" && items.title}
                      </p>
                    )}
                    <div className="clientForm__form__item">
                      <label>
                        <input
                          className="with-gap"
                          name={items.sk}
                          type="radio"
                          ref={register({ validate: validatorField })}
                          value="1"
                          onChange={(e) => handleChange2(e, "b", 1)}
                        />
                        <span>Sí</span>
                      </label>
                      <label>
                        <input
                          className="with-gap"
                          name={items.sk}
                          type="radio"
                          ref={register({ validate: validatorField })}
                          value="0"
                          onChange={(e) => handleChange2(e, "b", 0)}
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </>
                )}
              </div>
            ))}
            {showQuizTwo && (
              <div className="clientForm__container">
                <div className="clientForm__title">
                  Ingresa esta información
                </div>
                {quizTwo.map((items: any, index: number) => (
                    <Fragment key={index}>
                      {items.questionType === "formGroup" && items.metadata.classContainer !== "subQuestion" && (
                        <>
                          {items.childControls && (
                            items.childControls.map((child: any, index: number) => (
                                <Fragment key={index}>
                                  {child.questionType === "input" && (
                                    <div className="question__control input-field">
                                      {child.metadata && (
                                        <>
                                          {child.metadata.displayNumber && (
                                            <>
                                              <Controller
                                                as={NumberFormat}
                                                id={child.sk}
                                                name={child.sk}
                                                control={control}
                                                maxLength={child.metadata.maxLength}
                                                rules={{ required: true }}
                                              />
                                              <label htmlFor={child.sk}>
                                                {child.metadata.placeholder}
                                              </label>
                                          </>
                                          )}
                                          {!child.metadata.displayNumber && (
                                            <>
                                              <input
                                                id={child.sk}
                                                name={child.sk}
                                                type="text"
                                                autoComplete="off"
                                                maxLength={child.metadata.maxLength}
                                                ref={register({
                                                  validate: validatorField,
                                                })}
                                              />
                                              <label htmlFor={child.sk}>
                                                {child.metadata.placeholder}
                                              </label>
                                            </>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  )}
                                  {child.questionType === "inputGroup" && (
                                    <div className="question__control input-field">
                                      <div className="group-form">
                                        {child.childControls && child.childControls.map((childControl: any, index: number) => (
                                              <Fragment key={index}>
                                                {childControl.questionType === "input" && (
                                                  <>
                                                    {childControl.metadata.displayNumber && (
                                                      <>
                                                        {childControl.metadata.placeholder === "Años de labores" && (
                                                          <div className="question__control input-field percent">
                                                            <Controller
                                                              autoComplete="off"
                                                              as={NumberFormat}
                                                              id={childControl.sk}
                                                              name={childControl.sk}
                                                              control={control}
                                                              maxLength={childControl.metadata.maxLength}
                                                              rules={{
                                                                required: "*Revisa los datos ingresados.",
                                                                validate: validateNumberYear3,
                                                              }}
                                                            />
                                                            {/* <div className="tooltip">
                                                              El valor ingresado no puede ser mayor al año actual.
                                                            </div> */}
                                                            <label htmlFor={childControl.sk}>
                                                              {childControl.metadata && childControl.metadata.placeholder}
                                                            </label>
                                                            <ErrorCustom errors={errors} name={childControl.sk} />
                                                          </div>
                                                        )}
                                                      </>
                                                    )}
                                                    {!childControl.metadata.displayNumber && (
                                                      <div className="question__control input-field">
                                                        <input
                                                          id={childControl.sk}
                                                          name={childControl.sk}
                                                          type="text"
                                                          autoComplete="off"
                                                          maxLength={childControl.metadata.maxLength}
                                                          ref={register({
                                                            validate: validatorField,
                                                          })}
                                                        />
                                                        <label htmlFor={childControl.sk}>
                                                          {childControl.metadata.placeholder}
                                                        </label>
                                                      </div>
                                                    )}
                                                  </>
                                                )}
                                              </Fragment>
                                            )
                                          )
                                        }
                                      </div>
                                    </div>
                                  )}
                                </Fragment>
                              )
                            )
                          )}
                        </>
                      )}
                    </Fragment>
                  )
                )}
              </div>
            )}
          </div>

          {showQuizTwo && filteredQuizTwo && (
            <>
              {filteredQuizTwo.map((items: any, index: number) => (
                  <Fragment key={index}>
                    {items.questionType === "formGroup" &&
                      items.metadata.classContainer === "subQuestion" && (
                        <div className="healthCard">
                          <div className="clientForm__title">
                            Ingresa esta información
                          </div>
                          <div className="clientForm__area-title">
                            b.{index + 1}) {items.title}
                          </div>
                          {items.childControls &&
                            items.childControls.map(
                              (child: any, index: number) => (
                                <Fragment key={index}>
                                  {child.questionType === "inputGroup" && (
                                    <div className="question__control input-field">
                                      <div className="group-form">
                                        {child.childControls &&
                                          child.childControls.map(
                                            (
                                              childControl: any,
                                              index: number
                                            ) => (
                                              <Fragment key={index}>
                                                {childControl.questionType ===
                                                  "select" && (
                                                  <div className="question__control input-field">
                                                    <select
                                                      id={childControl.sk}
                                                      name={childControl.sk}
                                                      ref={register({
                                                        validate:
                                                          validatorField,
                                                      })}
                                                    >
                                                      <option
                                                        value={""}
                                                        disabled
                                                        selected
                                                      >
                                                        {
                                                          childControl.metadata
                                                            .placeholder
                                                        }
                                                      </option>
                                                      {childControl.metadata.options.map(
                                                        (
                                                          option: any,
                                                          idx: number
                                                        ) => (
                                                          <option
                                                            value={option}
                                                            key={idx}
                                                          >
                                                            {option}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                    <ErrorCustom
                                                      errors={errors}
                                                      name={childControl.sk}
                                                    />
                                                  </div>
                                                )}

                                                {childControl.questionType ===
                                                  "input" && (
                                                  <>
                                                    <div className="question__control input-field">
                                                      {childControl.metadata
                                                        .displayNumber && (
                                                        <>
                                                          <Controller
                                                            as={NumberFormat}
                                                            id={childControl.sk}
                                                            name={
                                                              childControl.sk
                                                            }
                                                            control={control}
                                                            maxLength={
                                                              childControl
                                                                .metadata
                                                                .maxLength
                                                            }
                                                            rules={{
                                                              required: true,
                                                            }}
                                                          />
                                                          <label
                                                            htmlFor={
                                                              childControl.sk
                                                            }
                                                          >
                                                            {
                                                              childControl
                                                                .metadata
                                                                .placeholder
                                                            }
                                                          </label>
                                                        </>
                                                      )}
                                                      {!childControl.metadata
                                                        .displayNumber && (
                                                        <>
                                                          <input
                                                            id={childControl.sk}
                                                            name={
                                                              childControl.sk
                                                            }
                                                            type="text"
                                                            autoComplete="off"
                                                            maxLength={
                                                              childControl
                                                                .metadata
                                                                .maxLength
                                                            }
                                                            ref={register({
                                                              validate:
                                                                validatorField,
                                                            })}
                                                          />
                                                          <label
                                                            htmlFor={
                                                              childControl.sk
                                                            }
                                                          >
                                                            {
                                                              childControl
                                                                .metadata
                                                                .placeholder
                                                            }
                                                          </label>
                                                        </>
                                                      )}
                                                    </div>
                                                  </>
                                                )}
                                              </Fragment>
                                            )
                                          )}
                                      </div>
                                    </div>
                                  )}

                                  {child.questionType === "select" && (
                                    <div className="question__control input-field">
                                      <select
                                        id={child.sk}
                                        name={child.sk}
                                        ref={register({
                                          validate: validatorField,
                                        })}
                                      >
                                        <option value={""} disabled selected>
                                          {child.metadata.placeholder}
                                        </option>
                                        {child.metadata.options.map(
                                          (option: any, idx: number) => (
                                            <option value={option} key={idx}>
                                              {option}
                                            </option>
                                          )
                                        )}
                                      </select>
                                      <ErrorCustom
                                        errors={errors}
                                        name={child.sk}
                                      />
                                    </div>
                                  )}

                                  {child.questionType === "input" && (
                                    <>
                                      <div
                                        className={
                                          "clientForm__control input-field percent" +
                                          (!child.required
                                            ? " is-optional"
                                            : "")
                                        }
                                      >
                                      <>
                                        {child.metadata.displayNumber ? (
                                          <Controller
                                            autoComplete="off"
                                            as={NumberFormat}
                                            id={child.sk}
                                            name={child.sk}
                                            control={control}
                                            maxLength={child.metadata.maxLength}
                                            rules={{
                                              validate: (value) => validateOptionalFields(value, child.metadata.placeholder),
                                            }}
                                          />
                                        ) : (
                                          <input
                                            type="text"
                                            autoComplete="off"
                                            id={child.sk}
                                            name={child.sk}
                                            ref={register({
                                              validate: (value) => validateOptionalFields(value, child.metadata.placeholder),
                                            })}
                                            maxLength={child.metadata.maxLength}
                                          />
                                        )}

                                        {child.metadata.placeholder ===
                                          "% de Participación" && (
                                          <span className="tooltip">
                                            El valor ingresado debe estar
                                            entre 25% y 100%.
                                          </span>
                                        )}
                                        <label htmlFor={child.sk}>
                                          {child.metadata.placeholder}
                                        </label>
                                        {!child.required && (
                                          <div>(opcional)</div>
                                        )}
                                      </>
                                      </div>
                                      <ErrorCustom
                                        errors={errors}
                                        name={child.sk}
                                      />
                                    </>
                                  )}
                                </Fragment>
                              )
                            )}

                          {filteredQuizTwo[0] && index === 0 && (
                            <div className="clientForm__container">
                              {parents.map((parent: any, index: number) => (
                                <ParentForm
                                  key={index}
                                  disableRemove={parents.length !== index + 1}
                                  parentsData={parentsData}
                                  parent={parent}
                                  index={index}
                                  removeParent={removeParent}
                                  count={parents.length}
                                />
                              ))}
                              <div
                                className={`clientForm__add ${
                                  !availableParents() ? "disabled-action" : ""
                                }`}
                                onClick={(e) => addItemControl(e, "parent")}
                              >
                                <IconPlus />
                                <p className="clientForm__add-text">
                                  Agregar Pariente
                                </p>
                              </div>
                            </div>
                          )}

                          {filteredQuizTwo[1] && index === 1 && (
                            <div className="clientForm__container">
                              {legalEntities.map(
                                (legalEntity: any, index: number) => (
                                  <LegalEntityForm
                                    key={index}
                                    disableRemove={
                                      legalEntities.length !== index + 1
                                    }
                                    legalEntitiesData={legalEntitiesData}
                                    legalEntity={legalEntity}
                                    index={index}
                                    removeLegalEntity={removeLegalEntity}
                                    count={legalEntities.length}
                                  />
                                )
                              )}
                              <div
                                className={`clientForm__add ${
                                  !availableLegalEntities()
                                    ? "disabled-action"
                                    : ""
                                }`}
                                onClick={(e) =>
                                  addItemControl(e, "legalEntity")
                                }
                              >
                                <IconPlus />
                                <p className="clientForm__add-text">
                                  Agregar Persona Jurídica
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                  </Fragment>
                )
              )}
            </>
          )}

          <div className="healthCard">
            {quizThree.map((items: any, index: any) => (
              <div key={index}>
                {items.questionType === "boolean" && (
                  <>
                    {!items.metadata.hiddenTitle && (
                      <p>
                        c){" "}
                        {items.metadata.numeration
                          ? `${items.metadata.numeration}) `
                          : ``}
                        {items.title !== "Otros datos" && items.title}
                      </p>
                    )}
                    <div className="clientForm__form__item">
                      <label>
                        <input
                          className="with-gap"
                          name={items.sk}
                          type="radio"
                          ref={register({ validate: validatorField })}
                          value="1"
                          onChange={(e) => handleChange3(e, "c", 1)}
                        />
                        <span>Sí</span>
                      </label>
                      <label>
                        <input
                          className="with-gap"
                          name={items.sk}
                          type="radio"
                          ref={register({ validate: validatorField })}
                          value="0"
                          onChange={(e) => handleChange3(e, "c", 0)}
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </>
                )}
              </div>
            ))}

            {showQuizThree && (
              <div className="clientForm__container">
                <div className="clientForm__title">
                  Ingresa esta información
                </div>
                {quizThree.map((items: any, index: number) => (
                  <Fragment key={index}>
                    {items.questionType === "formGroup" && (
                      <>
                        {items.childControls && (
                          items.childControls.map((child: any, index: number) => (
                              <Fragment key={index}>
                                {child.questionType === "input" && (
                                  <div className="question__control input-field">
                                    {child.metadata && (
                                      <>
                                        {child.metadata.displayNumber && (
                                          <>
                                            <Controller
                                              as={NumberFormat}
                                              id={child.sk}
                                              name={child.sk}
                                              control={control}
                                              maxLength={child.metadata.maxLength}
                                              rules={{ required: true }}
                                            />
                                            <label htmlFor={child.sk}>
                                              {child.metadata.placeholder}
                                            </label>
                                        </>
                                        )}
                                        {!child.metadata.displayNumber && (
                                          <>
                                            <input
                                              id={child.sk}
                                              name={child.sk}
                                              type="text"
                                              autoComplete="off"
                                              maxLength={child.metadata.maxLength}
                                              ref={register({
                                                validate: validatorField,
                                              })}
                                            />
                                            <label htmlFor={child.sk}>
                                              {child.metadata.placeholder}
                                            </label>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                )}
                                {child.questionType === "inputGroup" && (
                                  <div className="question__control input-field">
                                    <div className="group-form">
                                      {child.childControls && 
                                        child.childControls.map((childControl: any, index: number) => {
                                          
                                          return (
                                            <Fragment key={index}>
                                              {childControl.questionType ===
                                                "select" && (
                                                <div className="question__control input-field">
                                                  <select
                                                    id={childControl.sk}
                                                    name={childControl.sk}
                                                    ref={register({
                                                      validate: validatorField,
                                                    })}
                                                  >
                                                    <option
                                                      value={""}
                                                      disabled
                                                      selected
                                                    >
                                                      {
                                                        childControl.metadata
                                                          .placeholder
                                                      }
                                                    </option>
                                                    {childControl.metadata.options.map(
                                                      (option: any, idx: number) => (
                                                        <option
                                                          value={option}
                                                          key={idx}
                                                        >
                                                          {option}
                                                        </option>
                                                      )
                                                    )}
                                                  </select>
                                                  <ErrorCustom
                                                    errors={errors}
                                                    name={childControl.sk}
                                                  />
                                                </div>
                                              )}
                                              {childControl.questionType === "input" && (
                                                <div key={index} className="question__control input-field">
                                                  {childControl.metadata && (
                                                    <>
                                                      {childControl.metadata.displayNumber && (
                                                        <>
                                                          <Controller
                                                            as={NumberFormat}
                                                            id={childControl.sk}
                                                            name={childControl.sk}
                                                            control={control}
                                                            maxLength={childControl.metadata.maxLength}
                                                            rules={{ required: true }}
                                                          />
                                                          <label htmlFor={childControl.sk}>
                                                            {childControl.metadata.placeholder}
                                                          </label>
                                                      </>
                                                      )}
                                                      {!childControl.metadata.displayNumber && (
                                                        <>
                                                          <input
                                                            id={childControl.sk}
                                                            name={childControl.sk}
                                                            type="text"
                                                            autoComplete="off"
                                                            maxLength={childControl.metadata.maxLength}
                                                            ref={register({
                                                              validate: validatorField,
                                                            })}
                                                          />
                                                          <label htmlFor={childControl.sk}>
                                                            {childControl.metadata.placeholder}
                                                          </label>
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </div>
                                              )}
                                            </Fragment>
                                          )
                                        })
                                      }
                                    </div>
                                  </div>
                                )}
                              </Fragment>
                            )
                          )
                        )}
                      </>
                    )}
                  </Fragment>
                ))}

                <div className="clientForm__container">
                  {parentsPep.map((parentPep: any, index: number) => (
                    <ParentPepForm 
                      key={index}
                      disableRemove={parentsPep.length !== index + 1}
                      parentsPepData={parentsPepData}
                      parentPep={parentPep}
                      index={index}
                      removeParentPep={removeParentPep}
                      count={parentsPep.length}
                    />
                  ))}
                  <div className={`clientForm__add ${!availableParentsPep() ? "disabled-action" : ""}`} onClick={(e) => addItemControl(e, "parentPep")}>
                    <IconPlus />
                    <p className="clientForm__add-text">
                      Agregar Pariente
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Quiz;
